
export const getExclusives = 'exclusive/getExclusives';
export const queryExclusive = 'exclusive/queryExclusive';
export const ExclusiveSystem = 'exclusive/ExclusiveSystem';
export const createExclusive = 'exclusive/createExclusive';
export const calcExclusive = 'exclusive/calcExclusive';
export const deleteExclusive = 'exclusive/deleteExclusive';
export const renameExclusive = 'exclusive/renameExclusive';
export const calcRenew = 'exclusive/calcRenew';
export const dedicatedRenew = 'exclusive/dedicatedRenew';
export const QueryBillTypeByDedicatedIds = 'exclusive/QueryBillTypeByDedicatedIds';
export const tryDedicatedRenew = 'exclusive/tryDedicatedRenew';
export const tryDedicatedPositive = 'exclusive/tryDedicatedPositive';
export const exclusiveMonitor = 'exclusive/exclusiveMonitor';
export const CheckDedicatedHostCapacity = 'exclusive/CheckDedicatedHostCapacity';

export const getDedicatedCluster = 'exclusive/getDedicatedCluster';
export const modifyclusterName = 'exclusive/modifyclusterName';
export const createDedicatedCluster = 'exclusive/createDedicatedCluster';
export const delDedicatedCluster = 'exclusive/delDedicatedCluster';
export const migrateExclusiveCluster = 'exclusive/migrateExclusiveCluster';
export const setVCPU = 'exclusive/setVCPU';

export const exclusiveOverview = 'exclusive/exclusiveOverview';

export const DescribeTagKeysV2 = 'kec/DescribeTagKeysV2';
export const DescribeTagValuesV2 = 'kec/DescribeTagValuesV2';
export const ReplaceResourcesTagsV2 = 'kec/ReplaceResourcesTagsV2';
export const DetachResourceTagsV2 = 'kec/DetachResourceTagsV2';
export const ModifyVolumeType = 'kec/ModifyVolumeType';
export const ModifyEbsClusterMode = 'kec/ModifyEbsClusterMode';